import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import Button from "../../componentes/button/button";

export default function BPPageTabela({
  data,
  openModal,
  loading,
  service,
  usuarios,
  fetch,
  usuario,
  handleSort,
  sortConfig
}) {

  const [changeData, setChangeData] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [showCompartilhar, setShowCompartilhar] = useState(false);
  const [showDescompartilhar, setShowDescompartilhar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filters, setFilters] = useState({
    conta: [],
    centroCusto: [],
    filial: [],
    status: [],
    compartilhado: [],
    tipo: [],
    usuarioCompartilhado: []
  });


  useEffect(() => {
    const savedFilters = localStorage.getItem("filters");

    if (savedFilters) {
      const parsed = JSON.parse(savedFilters);

      setFilters({
        conta: parsed.conta ?? [],
        centroCusto: parsed.centroCusto ?? [],
        filial: parsed.filial ?? [],
        status: parsed.status ?? [],
        compartilhado: parsed.compartilhado ?? [],
        tipo: parsed.tipo ?? [],
        usuarioCompartilhado: parsed.usuarioCompartilhado ?? [],
      });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("filters", JSON.stringify(filters));
  }, [filters]);

  function toggleSelectedRow(id) {
    setSelectedRows(prev => {
      if (prev.includes(id)) {
        return prev.filter(item => item !== id);
      } else {
        return [...prev, id];
      }
    });
  }

  function toggleSelectAll() {
    if (selectedRows.length === changeData.length) {
      // desmarcar tudo
      setSelectedRows([]);
    } else {
      // selecionar todos
      setSelectedRows(changeData.map(row => row.id));
    }
  }

  function clearCompartilhamento() {
    setShowCompartilhar(false);
    setShowDescompartilhar(false);
    setSelectedRows([]);
    setUsuarioSelecionado(null);
  }

  function compartilharComUsuario() {
    service.compartilhar(selectedRows, usuarioSelecionado)
      .then(() => {
        toast.success(`${selectedRows.length} itens compartilhados.`);
        clearCompartilhamento();
        setFilters(prev => ({ ...prev, compartilhado: [] }))
      })
      .catch((e) => {
        console.error(e)
      })
  }

  function descompartilhar() {
    service.descompartilhar(selectedRows)
      .then(() => {
        toast.success(`${selectedRows.length} itens descompartilhados.`);
        clearCompartilhamento();
        setFilters(prev => ({ ...prev, compartilhado: [] }))
        fetch();
      })
      .catch(() => {
        toast.error("Erro ao descompartilhar itens.");
      });
  }


  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-table-border">
        <thead className="bg-table-header">
          <tr className="border-top">
            {(showCompartilhar || showDescompartilhar) &&
              <th className="px-6 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer">  </th>
            }

            <th className="px-6 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer" onClick={() => handleSort("filial.nome")}>
              Filial {sortConfig?.key === "filial.nome" && (sortConfig?.direction === "asc" ? "↑" : "↓")}
            </th>

            <th className="px-6 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer" onClick={() => handleSort("conta.reduzido")}>
              Conta {sortConfig?.key === "conta.reduzido" && (sortConfig?.direction === "asc" ? "↑" : "↓")}
            </th>

            <th className="px-6 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer" onClick={() => handleSort("conta.descricao")}>
              Conta Descrição {sortConfig?.key === "conta.descricao" && (sortConfig?.direction === "asc" ? "↑" : "↓")}
            </th>

            <th className="px-6 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer" onClick={() => handleSort("centroCusto.codigo")}>
              C.C {sortConfig?.key === "centroCusto.codigo" && (sortConfig?.direction === "asc" ? "↑" : "↓")}
            </th>

            <th className="px-6 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer" onClick={() => handleSort("centroCusto.descricao")}>
              C.Custo Desc {sortConfig?.key === "centroCusto.descricao" && (sortConfig?.direction === "asc" ? "↑" : "↓")}
            </th>

            <th className="px-6 py-3 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer" onClick={() => handleSort("conta.tipo")}>
              Tipo Conta {sortConfig?.key === "conta.tipo" && (sortConfig?.direction === "asc" ? "↑" : "↓")}
            </th>

            <th className="px-6 py-3 text-right text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer" onClick={() => handleSort("valorTotalRealizado")}>
              Realizado em 2025 {sortConfig?.key === "valorTotalRealizado" && (sortConfig?.direction === "asc" ? "↓" : "↓")}
            </th>

            <th className="px-6 py-3 text-right text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer" onClick={() => handleSort("valorTotal")}>
              <strong> Total em 2026 </strong> {sortConfig?.key === "valorTotal" && (sortConfig?.direction === "asc" ? "↓" : "↑")}
            </th>

            <th className="px-6 py-3 text-center text-xs font-medium text-table-header-fg uppercase tracking-wider">Status</th>
          </tr>
          <tr className="border-top">
            {(showCompartilhar) || (showDescompartilhar) ?
              <>
                {(showCompartilhar || showDescompartilhar) &&
                  <th className="px-6 py-3 w-16 text-left text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer">
                    {(showCompartilhar || showDescompartilhar) ? (
                      <input
                        type="checkbox"
                        className="w-4 h-4 cursor-pointer"
                        checked={selectedRows.length === changeData.length && changeData.length > 0}
                        onChange={toggleSelectAll}
                        onClick={(e) => e.stopPropagation()} // evita triggers de sort
                      />
                    ) : (
                      <i className="">#</i>
                    )}
                  </th>
                }
                <th colSpan={9} >
                  <div className="py-1 flex gap-2 w-full fade-in">
                    {showCompartilhar &&
                      <div className="w-64">
                        <Dropdown
                          value={usuarioSelecionado}
                          onChange={(e) => setUsuarioSelecionado(e.target.value)}
                          options={usuarios}
                          optionValue="id"
                          optionLabel="nome"
                          filter
                          showClear
                          placeholder="Selecione o usuário"
                          emptyMessage="Nenhuma opção a exibir"
                          filterPlaceholder="Buscar..."
                          className="w-full h-[41.33px] text-sm"
                          panelClassName="rounded-xl shadow-lg"
                        />
                      </div>
                    }
                    {showCompartilhar &&
                      <Button
                        variant="indigo"
                        textColor="white"
                        label="Compartilhar"
                        className="btn-sm"
                        disabled={!usuarioSelecionado || selectedRows.length < 1}
                        onClick={compartilharComUsuario}
                      />
                    }
                    {showDescompartilhar &&
                      <Button
                        variant="red"
                        textColor="white"
                        label="Remover Acesso"
                        className="btn-sm"
                        disabled={selectedRows.length < 1}
                        onClick={descompartilhar}
                      />
                    }
                    <Button
                      variant="white"
                      textColor="black"
                      label="Cancelar"
                      className="btn-sm"
                      onClick={() => {
                        setShowCompartilhar(false);
                        setShowDescompartilhar(false);
                        setUsuarioSelecionado(null);
                        setFilters(prev => ({ ...prev, compartilhado: [] }))
                        setSelectedRows([]);
                      }}
                    />
                  </div>
                </th>
              </>
              :
              null
            }
          </tr>
        </thead>
        <tbody className={`fade-in bg-card divide-y divide-table-border ${loading && 'opacity-50 pointer-events-none'}`}>
          {
            data.page.totalElements === 0 ? (
              <tr>
                <td colSpan={9} className="text-center py-4 text-muted-foreground text-sm">
                  Nenhum registro encontrado
                </td>
              </tr>
            ) : (
              data.content.map((row, index) => (
                <tr
                  key={row.id}
                  className={`highlight-row cursor-pointer transition-colors duration-150
                      ${row.contaOrcada ? 'bg-success/5 hover:bg-success/10 ' : 'bg-amber-50 hover:bg-muted '}
                      ${row.compartilhado && 'bg-accent hover:bg-accent/70 '}
                      ${row.compartilhado && row.contaOrcada && 'bg-teal-200 hover:bg-teal-300 '} `}                    >
                  {(showCompartilhar || showDescompartilhar) &&
                    <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-muted-foreground w-16">
                      <input
                        type="checkbox"
                        className="w-4 h-4 cursor-pointer"
                        checked={selectedRows.includes(row.id)}
                        onChange={() => toggleSelectedRow(row.id)}
                        onClick={(e) => e.stopPropagation()} // impede abrir modal
                      />
                    </td>
                  }
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-foreground font-bold">{row.filialNome}</td>
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-foreground">{row.contaReduzido}</td>
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-foreground">{row.contaDescricao}</td>
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-foreground">{row.centroCustoCodigo} </td>
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-foreground">{row.centroCustoDescricao}</td>
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-foreground">{row.contaTipo}</td>
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-right text-foreground">
                    {row.valorTotalRealizado?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-sm text-right text-foreground font-bold">
                    {row.valorTotal?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                  <td onClick={() => openModal(row)} className="px-6 py-2 text-center">
                    {row.contaOrcada ? (
                      <span className="px-2 py-1 bg-success/15 text-success rounded-full text-xs">
                        Realizado
                      </span>
                    ) : (
                      <span className="px-2 py-1 bg-amber-200 text-amber-900 rounded-full text-xs">
                        Pendente
                      </span>
                    )}
                  </td>
                </tr>
              ))
            )
          }
        </tbody>
      </table>
    </div>
  );
}